var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"bar","height":"350","options":_vm.apexChatData.barChart.chartOptions,"series":_vm.apexChatData.barChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }